<template>
    <div>
        <rkm-area type="fieldset" :title="`Medicamentos pendentes (${totalMedicamentosPendentes})`">
            <rkm-table
                :fields="fields.table"
                :items="localItems"
                hide-filters
                hide-pagination
                ref="table"
                thead-class="d-none"
            >
                <template v-slot:cell(medicoSolicitante.nome)="{ item }">
                    <strong>Médico solicitante:</strong> {{ item.medicoSolicitante.cidadaoNome }}
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        :color="item.observacao ? 'info' : 'secondary'"
                        small
                        v-rkm-popover.hover.left="{
                            title:'Observação',
                            html:true,
                            content: item.observacao
                                ? item.observacao
                                : 'Nenhuma observação informada.',
                        }"
                    >
                        <i class="fas fa-comment-alt"></i>
                    </rkm-button>

                    <rkm-button
                        @click="dispensar(item)"
                        color="primary"
                        small
                        title="Dispensar"
                    >
                        <rkm-icon icon="hand-holding-medical" />
                    </rkm-button>
                </template>

                <template #row-details="item">
                    <rkm-table
                        :fields="fields.detail"
                        :items="filterDeletedItems(item.item.items)"
                        hide-filters
                        hide-pagination
                        sort-by="vencimentoReceita"
                        tbody-tr-class="font-weight-normal"
                    >
                        <template v-slot:cell(actions)="{ item }">
                            <rkm-button
                                :color="item.observacao ? 'info' : 'secondary'"
                                small
                                v-rkm-popover.hover.left="{
                                    title:'Observação',
                                    html:true,
                                    content: item.observacao
                                        ? item.observacao
                                        : 'Nenhuma observação informada.',
                                }"
                            >
                                <i class="fas fa-comment-alt"></i>
                            </rkm-button>

                            <rkm-button
                                @click="destroy(item)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
//mixins
import { object } from '@/mixins'

export default {
    computed: {
        fields() {

            return {
                table: [
                    { key: "medicoSolicitante.nome", label: "Médico solicitante", sortable: true },
                    { key: "actions", label: "Açoes", class: "col-min" },
                ],
                detail: [
                    { key: "vencimentoReceita", label: "Vencimento", sortable: true },
                    { key: "material.descricao", label: "Medicamento", sortable: true },
                    { key: "ultimaSaida", label: "Última saída", sortable: true },
                    { key: "saldo", label: "Saldo", sortable: true, class:"text-center" },
                    { key: "proximaRetirada", label: "Próxima retirada", sortable: true },
                    { key: "actions", label: "Açoes", class: "col-min" },
                ],
            }
        },
    },
    created() {

        this.localItems = this.mappedItems()
    },
    methods: {
        dispensar(item) {

            const receita = this.clone(this.items.find(i => i.id === item.id))

            this.$emit('dispensar', receita)
        },
        mappedItems() {

            return this.items.filter(receita => receita.items.some(item => !item.deleted))
        },
        filterDeletedItems(receitaItems) {

            return receitaItems.filter(f => !f.deleted)
        },
        destroy(item) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o item selecionado?',
                async () => {

                    this.items.map(receita => {

                        receita.items.map(mItem => {

                            if (mItem.id === item.id) {

                                this.$set(mItem, 'deleted', true)
                                return false
                            }
                        })
                    })
                }
            )
        },
    },
    data: () => ({

        localItems: []
    }),
    mixins: [object],
    props: {
        items: { type: Array, default: () => [] },
        totalMedicamentosPendentes: { type: Number, default: 0 },
    },
    watch: {
        'items': {
            deep: true,
            handler() {

                this.localItems = this.mappedItems()
            }
        }
    }
}
</script>